import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/modules/auth/auth.service';
import { LayoutService } from 'src/app/services/layout.service';
import { NavService } from 'src/app/services/nav.service';
import { MessageInboxItem, UserProfile } from 'src/app/web-api-client';
import { WtStorageService } from 'src/app/wt-storage.service';
import { ReadMailComponent } from '../mails/read-mail/read-mail.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageBoxComponent } from './message-box/message-box.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent implements OnInit {
  public dark: boolean =
    this.layout.config.settings.layout_version == 'dark-only' ? true : false;

  public userProfile: UserProfile;
  collapseSidebar: boolean = true;

  @ViewChild(MessageBoxComponent) messageBox: MessageBoxComponent;

  constructor(
    private navServices: NavService,
    public layout: LayoutService,
    public authService: AuthService,
    public localCahce: WtStorageService,
    public changeDetectionRef: ChangeDetectorRef,
    private readonly modalService: NgbModal,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit(): void {

    if(this.authService.isAuthenticated()){
      this.userProfile = this.localCahce.getuser();
      this.changeDetectionRef.detectChanges();
    }

    this.authService.isAuthenticated$.subscribe((isAuthenticated)=>{
      if(isAuthenticated){
        this.userProfile = this.localCahce.getuser();
        this.changeDetectionRef.detectChanges();
      }
    });
  }

  sidebarToggle() {
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
  }

  layoutToggle() {
    this.document.body.classList.toggle('dark-only');
  }
  languageToggle() {
    this.navServices.language = !this.navServices.language;
  }
  searchToggle() {
    this.navServices.search = true;
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    const element = document.getElementById('sidebar-toggle');
    if (element && window.innerWidth > 1199) {
      element.style.display = 'none';
    } else if (element) {
      element.style.display = 'block';
    }

    this.changeDetectionRef.detectChanges();
  }


  public onMessageSelect(event: MessageInboxItem) {
    let modalRef = this.modalService.open(ReadMailComponent, { size: 'xl', centered: true, backdrop: 'static' });
    modalRef.componentInstance.message = event;
    modalRef.componentInstance.onClose.subscribe(r => {
      // Refresh the message box when modal closes
      if (this.messageBox) {
        this.messageBox.refresh();
      }
    });
  }

}
